import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

import cs from 'classnames';
import { bindActionCreators } from 'redux';

import { EVENTS } from 'shared/constants/gtmEvents';
import { setDataLayer } from 'shared/actions/globals';
import { withTranslate } from 'shared/hocs/withTranslate';
import { withFetch } from 'shared/hocs/withFetch';
import { enqueueNotification } from 'shared/actions/notifications';
import { fireRTBEvent } from 'shared/helpers/rtbHouse';
import { getPrice } from 'shared/helpers/advert';
import { userFormValidation } from 'shared/helpers/leasing/utils';

// import FormInput from './Inputs/FormInput';
import {
  prepareParamsForCreditMarketRequest,
  sendCreditMarket,
} from 'shared/helpers/leasing/creditmarket';

import UserDataForm from './UserDataForm/UserDataForm';
import UserDataFormWithPhotoDialogWrapper from './UserDataForm/UserDataFormWithPhotoDialogWrapper';

// eslint-disable-next-line css-modules/no-unused-class
import s from './LeasingOnlineBanner.css';

class CreditMarketBanner extends React.Component {
  static propTypes = {
    modalMode: PropTypes.bool,
    advert: PropTypes.shape().isRequired,
    setDataLayer: PropTypes.func.isRequired,
    onSubmited: PropTypes.func,
    eventPostfix: PropTypes.string,
    // isNotCleared: PropTypes.bool,
    //
    fetch: PropTypes.func.isRequired,
    t: PropTypes.func.isRequired,
    enqueueNotif: PropTypes.func.isRequired,
    user: PropTypes.shape(),
  };

  static defaultProps = {
    eventPostfix: '',
    modalMode: true,
    onSubmited: () => {},
    user: null,
    // isNotCleared: false,
  };

  constructor(props) {
    super(props);
    const { user } = this.props;
    const userName = (user && user.name) || '';
    const phone = (user && user.phones && user.phones[0].number) || '';

    this.state = {
      userName,
      birthday: '',
      phone,
      errorMessage: '',
      successMessage: '',
      codeVerification: '',
      requestId: '',
      isLeasingApproved: false,

      disableBtnLeasing: false,
      disableBtnLeasingOnline: false,
      disableBtnCodeVerification: false,
    };
  }

  onSubmitUesrDataForm = e => {
    e.preventDefault();
    const { enqueueNotif, t } = this.props;
    const { phone, userName } = this.state;
    const errorMsg = userFormValidation({ phone, userName });
    if (errorMsg) {
      this.setState({ errorMessage: errorMsg });
      return;
    }

    this.pushEvent('consultation-form-sumbit');
    this.setState({ disableSubmit: true });
    this.Submit(data => {
      this.setState({ disableSubmit: false });
      const toState = {
        userName: '',
        phone: '',
        errorMessage:
          !data || data.result !== 'ok'
            ? 'Извините, произошла ошибка на сервере, попробуйте повторить операцию позже'
            : '',
        successMessage: '',
      };

      this.setState(toState);
      if (data && data.result === 'ok') {
        enqueueNotif(t('Заявка отправлена'));
        this.pushEvent('lead-create-success');
      } else {
        enqueueNotif(
          t('Извините, произошла ошибка на сервере, попробуйте повторить операцию позже'),
        );
        this.pushEvent('lead-create-fail');
      }
      this.props.onSubmited();
    });
  };

  Submit = cb => {
    const { phone, userName } = this.state;
    const { advert, fetch } = this.props;

    const params = prepareParamsForCreditMarketRequest({ ...advert, phone, userName });
    sendCreditMarket(params, fetch).then(data => cb(data)).catch(() => cb(false));
  };

  changeHandler = (field, value) => {
    this.setState({ [field]: value, errorMessage: '' });
  };

  pushEvent = eventName => {
    if (eventName === 'lead-create-success') {
      fireRTBEvent('leasingOld', {
        value: this.props.advert.price && getPrice(this.props.advert.price),
        ids: [this.props.advert.id],
      });
    }

    const { eventPostfix } = this.props;
    const event = `creditmarket-${eventName}${eventPostfix ? `-${eventPostfix}` : ''}`;
    if (EVENTS.leasing[event]) this.props.setDataLayer(EVENTS.leasing[event]);
    else console.error(`Event: ${event} not found.`);
  };

  render() {
    const { t, advert } = this.props;
    const PRICE_UAH = advert.is_not_cleared ? '300 000' : '140 000';

    const titleHTML = `${t('Финансируем')}<br /> до <b> ${PRICE_UAH} грн. </b><br /> ${t(
      'на этот автомобиль',
    )}`;
    return (
      <div
        className={cs({
          [s.container]: true,
          [s.LeasingContainerContentSidebar]: !this.props.modalMode,
        })}
      >
        <UserDataFormWithPhotoDialogWrapper
          advertInfo={this.props.advert}
          showTitle={!this.props.modalMode}
          titleHTML={titleHTML}
        >
          <UserDataForm
            disableBtnLeasing={this.state.disableSubmit}
            userName={this.state.userName}
            phone={this.state.phone}
            birthday={this.state.birthday}
            errorMessage={this.state.errorMessage}
            successMessage={this.state.successMessage}
            changeHandler={this.changeHandler}
            onSubmitHandler={this.onSubmitUesrDataForm}
          />
        </UserDataFormWithPhotoDialogWrapper>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user && state.user.user,
});

const mapDispatchToProps = dispatch => ({
  enqueueNotif: bindActionCreators(enqueueNotification, dispatch),
  setDataLayer: bindActionCreators(setDataLayer, dispatch),
});

export default withStyles(s)(
  withFetch(withTranslate(connect(mapStateToProps, mapDispatchToProps)(CreditMarketBanner))),
);



// WEBPACK FOOTER //
// ./src/shared/components/LeasingOnlineBanner/CreditMarketBanner.js